export default __webpack_public_path__ + "static/media/028-bullet-1.7e3f5f8d.png";